import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";

function Home() {
  return (
    <Container sx={{ marginTop: 12 }} maxWidth={false}>
      <Typography sx={{ marginBottom: 2 }} variant="h4">
        MetaResearch.se
      </Typography>
      <Typography>
        MetaResearch.se is maintained by Gustav Nilsonne's research team at
        Karolinska Institutet. More information about the team's ongoing
        research can be found at{" "}
        <Link href="https://nilsonne.net">nilsonne.net</Link>. This website
        presents data on{" "}
        <Link href="/nordic-trials-dashboard">
          clinical trials transparency in the Nordic countries
        </Link>
        . This website also provides <Link href="/trialscout">TrialScout</Link>,
        an AI-assisted tool to match publications to trials registered on
        clinicaltrials.gov. For questions regarding the site or if you want to
        submit a bug report, please{" "}
        <Link href="mailto:love.ahnstrom@ki.se">email us</Link> or submit an
        issue on{" "}
        <Link href="https://github.com/lahnstrom/vis-nordic">GitHub</Link>. .
      </Typography>
    </Container>
  );
}

export default Home;
